import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const ContactBook = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path d="M18.422 4.02V3.01c0-.56-.46-1.01-1.01-1.01-.56 0-1.01.46-1.01 1.01v1.01h-8.1V3.01c0-.55-.46-1.01-1.01-1.01-.56 0-1.01.46-1.01 1.01v1.01" />
    <Path d="M6.883 3.88c-.36.06-.54.09-.91.16-1.01.2-2.03 1.23-2.23 2.23-.99 5.1-.99 7.65 0 12.76.19 1 1.21 2.03 2.23 2.23 5.1.99 7.65.99 12.76 0 1-.19 2.03-1.22 2.23-2.23.99-5.1.99-7.65 0-12.76-.19-1-1.23-2.03-2.23-2.23-.36-.07-.55-.1-.91-.16-4.38-.73-6.56-.73-10.94 0Zm5.47 3.64c1.62 0 3 1.44 3.04 3.12.04 1.68-1.34 3.04-3.04 3.04s-3.08-1.36-3.04-3.04c.05-1.7 1.43-3.12 3.04-3.12Zm5.85 10.98c0 .89-11.69.89-11.69 0-.04-.38-.06-.59-.09-.97-.17-1.94 3.9-2.93 5.94-2.93 2.03 0 6.1.97 5.94 2.93l-.1.97Zm-5.85-.54a1.071 1.071 0 0 1 0-2.14 1.071 1.071 0 0 1 0 2.14Z" />
  </Icon>
);

export default ContactBook;
